import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from "vuetify/es5/locale/es";
import "@mdi/font/css/materialdesignicons.css"
import "typeface-roboto/index.css"

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#0b1f73",
            },
        },
        options: {
            customProperties: true,
        },
    },
    lang: {
        locales: { es },
        current: "es",
    },
    icons: {
        iconfont: "mdi",
    },
});
